import { useSharedProjectAttachmentsModel } from "widgets/project-attachments/hooks/useSharedProjectAttachmentsModel"

import { ProjectAttachmentsOverlayConnectorProps } from "../ProjectAttachmentsOverlayConnector"

export function useSharedProjectAttachmentsOverlayModel({
  payload: { projectID }
}: ProjectAttachmentsOverlayConnectorProps) {
  const attachmentsModel = useSharedProjectAttachmentsModel({ projectID })

  return { attachmentsModel }
}
